import { createApp } from "vue"
import { createPinia } from "pinia"
import App from "@/App.vue"
import router from "@/router"
import { http } from "@/lib/api"
import { i18n } from "@/i18n"
import { useAuthStore } from "@/stores/auth"
import "@/styles.css"

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(i18n)
app.use(router)

const auth = useAuthStore(pinia)
http.onUnauthorized(() => {
  const hadSession = auth.authenticated
  auth.clear()
  if (hadSession && router.currentRoute.value.meta.requiresAuth) {
    void router.replace({ name: "login", query: { redirect: router.currentRoute.value.fullPath, expired: "1" } })
  }
})

app.mount("#app")
